var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeletePrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95147 6.64853C5.17652 6.87357 5.48174 7 5.8 7C6.11826 7 6.42348 6.87357 6.64853 6.64853C6.87357 6.42348 7 6.11826 7 5.8C7 5.48174 6.87357 5.17652 6.64853 4.95147C6.42348 4.72643 6.11826 4.6 5.8 4.6C5.48174 4.6 5.17652 4.72643 4.95147 4.95147C4.72643 5.17652 4.6 5.48174 4.6 5.8C4.6 6.11826 4.72643 6.42348 4.95147 6.64853ZM11.328 3.464L18.528 10.664C18.816 10.952 19 11.352 19 11.8C19 11.8951 18.9918 11.9883 18.9759 12.079C18.6583 12.027 18.3323 12 18 12C14.6863 12 12 14.6863 12 18C12 18.332 12.027 18.6577 12.0788 18.975C11.9882 18.9914 11.8951 19 11.8 19C11.36 19 10.96 18.816 10.664 18.528L3.472 11.328C3.176 11.04 3 10.64 3 10.2V4.6C3 3.712 3.712 3 4.6 3H10.2C10.64 3 11.04 3.176 11.328 3.464Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 14.5L21.57 15.92L19.44 18.04L21.57 20.16L20.15 21.58L18.03 19.45L15.91 21.58L14.5 20.16L16.62 18.04L14.5 15.92L15.91 14.51L18.03 16.63L20.15 14.5Z",
    fill: "#B00020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePrice);
export default __webpack_public_path__ + "static/media/deletePrice.203d3d5bfc8d3f96040eecef016015b1.svg";
export { ForwardRef as ReactComponent };